import { render, staticRenderFns } from "./TotalFilteredRows.vue?vue&type=template&id=0c56d3a8&"
import script from "./TotalFilteredRows.vue?vue&type=script&lang=js&"
export * from "./TotalFilteredRows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports